// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7f4d4b73","239":"9bdd0f14","455":"8cf25fc5"}[chunkId] + ".chunk.js";
};